interface StepProgressProps {
  currentStep: 1 | 2 | 3 | 4;
}

export function StepProgress({ currentStep }: StepProgressProps) {
  return (
    <div className="flex items-center gap-2" aria-label={`Etapa ${currentStep} de 4`}>
      {[1, 2, 3, 4].map((step) => (
        <div
          key={step}
          className={`h-1 flex-1 rounded-full ${step <= currentStep ? 'bg-rchlo-green' : 'bg-gray-200'}`}
        />
      ))}
    </div>
  );
}